import React, { useState } from "react";
import { PropTypes } from "prop-types";
import { Button, IconButton, Menu, MenuItem } from "@mui/material";

const MenuButton = ({
  onClick,
  children,
  menuItems,
  isIconButton,
  ...buttonProps
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = value => {
    onClick(value);
    handleClose();
  };

  const ButtonComponent = isIconButton ? IconButton : Button;

  return (
    <div>
      <ButtonComponent
        aria-controls="button-menu"
        aria-haspopup="true"
        onClick={handleClick}
        {...buttonProps}
      >
        {children}
      </ButtonComponent>
      <Menu
        id="button-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {menuItems.map(({ value, label }) => (
          <MenuItem
            onClick={() => handleSelect(value)}
            value={value}
            key={value}
          >
            {label}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

export default MenuButton;

MenuButton.propTypes = {
  menuItems: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string
    })
  ).isRequired,
  isIconButton: PropTypes.bool,
  onClick: PropTypes.func
};

MenuButton.defaultProps = {
  isIconButton: false,
  variant: "contained",
  color: "primary"
};
